export interface Job {
  id: string;
  contractId: string;
  title: string;
  description?: string;
  status: JobStatus;
  priority: JobPriority;
  dueDate?: Date;
  startDate?: Date;
  completedDate?: Date;
  assignedTo?: string[];
  tags?: string[];
  attachments?: Attachment[];
  estimatedHours?: number;
  actualHours?: number;
  progress?: number;
  createdAt: Date;
  updatedAt: Date;
}

export enum JobStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  IN_PROGRESS = 'in-progress',
  ON_HOLD = 'on-hold',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum JobPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

export interface Attachment {
  id: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  url: string;
  uploadedBy: string;
  uploadedAt: Date;
}
